module.exports = __webpack_public_path__ + "img/background-dark.adb7157b.webp";